<template>
  <div class="zy_about_advantage">
    <h1 class="zy_about_title">业务优势</h1>
    <div class="zy_about_advantage_list">
      <div
        class="zy_about_advantage_item"
        v-for="item in ADVANTAGE"
        :key="item.id"
        :style="{ backgroundImage: `url(${item.bg_wap})` }"
      >
        <p class="zy_about_advantage_item_title">{{ item.name }}</p>
        <p class="zy_about_advantage_item_desc">{{ item.desc }}</p>
        <a :href="item.href" class="zy_about_advantage_item_btn"></a>
      </div>
      <!-- 占位符: 解决小米手机谷歌浏览器，小米手机 QQ浏览器,oppo pad自带浏览器  zy_about_advantage_list设置padding-right 后不生效的bug-->
      <div class="zy_about_advantage_item_placeholder"></div>
    </div>
  </div>
</template>

<script>
import { ADVANTAGE } from '@/config';
export default {
  data() {
    return {
      ADVANTAGE
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';
.zy_about_advantage {
  margin-bottom: rem(36);
  &_list {
    display: flex;
    flex-wrap: nowrap;
    padding-left: rem(48);
    overflow-x: auto;
    /* 隐藏滚动条 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }
  }
  &_item_placeholder {
    flex-shrink: 0;
    width: rem(48);
  }
  &_item {
    flex-shrink: 0;
    background-color: rgba(248, 248, 250, 1);
    width: rem(750);
    border-radius: rem(36);
    margin-left: rem(24);
    padding-top: rem(360);
    text-align: center;
    background-size: 100% rem(360);
    background-repeat: no-repeat;
    background-position: top center;
    &:first-child {
      margin-left: 0;
    }
    &_title {
      font-size: rem(42);
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: rem(54);
    }
    &_desc {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: rem(36);
      color: rgba(0, 0, 0, 0.85);
      line-height: rem(54);
      margin-top: rem(42);
      padding: 0 rem(42);
    }
    &_btn {
      display: inline-block;
      width: rem(72);
      height: rem(72);
      background: url('https://static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/4dde53ca-ef67-4e42-ba0c-9d10534e9377.png')
        no-repeat center center;
      background-size: 100%;
      margin: rem(24) 0;
    }
  }
}
.zy_about_title {
  text-align: center;
  padding: rem(15 * 3) 0 rem(24 * 3);
  font-size: rem(60);
}
</style>
